<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          <b>Deletar {{ item?.nome }}</b>
        </p>
        <button type="button" class="delete" @click="cancel" />
      </header>
      <section class="modal-card-body">
        <p>
          Deseja realmente remover <b>{{ item?.nome }}</b>?
        </p>
        <p>Esta ação não poderá ser desfeita!</p>
        <br>
        <b><p>* Todos os documentos vinculados a esta item serão excluídos.</p></b>
      </section>
      <footer class="modal-card-foot">
        <b-button native-type="button" type="is-danger" outlined @click="cancel">
          Cancelar
        </b-button>
        <b-button type="is-danger" @click="confirm">
          Deletar
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { defineComponent } from 'vue';
import PessoaService from '@/services/PessoaService';

export default defineComponent({
  name: 'ModalDeletePessoa',
  props: {
    isActive: Boolean,
    item: Object, // Recebe o objeto da pessoa a ser deletada
  },
  emits: ['cancel', 'confirm'],
  data() {
    return {
      isModalActive: this.isActive, // Controla a visibilidade do modal
    };
  },
  watch: {
    isActive(newVal) {
      this.isModalActive = newVal; // Sincroniza o estado do modal com a prop isActive
    },
  },
  methods: {
    confirm() {
      const id = this.item.id; // Obtém o ID da item

      PessoaService.deletePessoa(id)
        .then(() => {
          this.$buefy.toast.open({
            message: `Pessoa Deletada!`,
            position: 'is-bottom',
            type: 'is-info',
          });
          this.$emit('confirm'); // Emite o evento de confirmação
          this.isModalActive = false; // Fecha o modal
          location.reload(); // Recarrega a página (opcional)
        })
        .catch((error) => {
          if (error.response) {
            this.$buefy.toast.open({
              message: `Erro ao deletar Pessoa: ${error.response.data.message}`,
              position: 'is-bottom',
              type: 'is-danger',
            });
          }
          console.error(error);
        });
    },
    cancel() {
      this.$emit('cancel'); // Emite o evento de cancelamento
      this.isModalActive = false; // Fecha o modal
    },
  },
});
</script>